import {Component, Input, OnInit} from '@angular/core';
import {Pagination} from "@core/bean/pagination";
import {HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {CommonsService} from "@core/service/commons.service";
import {BrowseConfig} from "@core/bean/browse-config";
import {NzModalService} from "ng-zorro-antd";
import {PurchaseOrderService} from "../../../../routes/jy-srm/order/purchase-order/purchase-order.service";
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styles: []
})
export class PurchaseOrderComponent implements BrowseComponent, OnInit {

  // static componentName = 'PurchaseOrderBrowseComponent';

  // PurchaseOrderComponent

  static componentName ='PurchaseOrderComponent';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private purchaseOrderService:PurchaseOrderService
  ) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return purchaseOrderService.query(params);
    }
  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

}
